import { ToastVariant } from '@up2rent/ui-new';

export enum PeppolRegistrationCheck {
  REGISTERED = 'REGISTERED',
  NOT_REGISTERED = 'NOT_REGISTERED',
  UNAVAILABLE = 'UNAVAILABLE',
}

const PEPPOL_REGISTRATION_CHECK_MESSAGE_IDS: Record<PeppolRegistrationCheck, string> = {
  [PeppolRegistrationCheck.REGISTERED]: 'lease.peppol.companyVerified',
  [PeppolRegistrationCheck.NOT_REGISTERED]: 'lease.peppol.companyNotVerified',
  [PeppolRegistrationCheck.UNAVAILABLE]: 'lease.peppol.companyVerificationUnavailable',
};

export const getPeppolRegistrationCheckFeedback = (check: PeppolRegistrationCheck) => ({
  messageId: PEPPOL_REGISTRATION_CHECK_MESSAGE_IDS[check],
  variant: check === PeppolRegistrationCheck.REGISTERED ? ToastVariant.SUCCESS : ToastVariant.ERROR,
});

/**
 * One answer for several parties: a party the directory does not know is reported before an outage, because
 * the user can act on it (fix the business number) while an outage only calls for a retry.
 */
export const combinePeppolRegistrationChecks = (checks: PeppolRegistrationCheck[]): PeppolRegistrationCheck => {
  if (checks.includes(PeppolRegistrationCheck.NOT_REGISTERED)) {
    return PeppolRegistrationCheck.NOT_REGISTERED;
  }
  if (checks.includes(PeppolRegistrationCheck.UNAVAILABLE)) {
    return PeppolRegistrationCheck.UNAVAILABLE;
  }
  return PeppolRegistrationCheck.REGISTERED;
};
